import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Row, Col, ControlLabel, Input } from 'rsuite'
import moment from 'moment/moment'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'

import ConfirmWidget from '../confirm/ConfirmWidget'
import { cloneDeep } from 'lodash-es'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  requiredFiled,
  isValidators,
  getMaxLengthData,
  hasMinValidator,
} from '../../utils/ValidatorUtils'
import { budgetFormat } from '../../utils/formatterUtil'
import { getValueFromOptions } from '../../utils/dataUtil'
import { v4 as uuidv4 } from 'uuid'
import AlertWidget from '../confirm/AlertWidget'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import EditDateCustomCell from '../../components/cell/EditDateCustomCell'
import '../../widgets/projectBasedItemsWidget/styles_table.less'

export default function AdvanceRefundTable({
  schema,
  loading,
  isEnableEdit,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  borrowAmont = 0,
  setBorrowAmont = () => {},
  payActive = '',
  setPayActive = () => {},
  activityRelationsList = [],
  disabledForm = false,
  isViewMode,
  assetInputReason,
  assetInputAlertDescription,
  isAddDisabled,
  ...props
}) {
  const { isReceiveAnnuity } = props
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [masterTableData, setMasterTableData] = useState(schema.values)
  const [showControlEdit, setShowControlEdit] = useState(true)
  const [showModalDurableArticles, setShowModalDurableArticles] = useState(false)
  const [listOptions, setListOptions] = useState([])
  const [showWarning, setShowWarning] = useState(false)
  const [showAdditional, setShowAdditional] = useState(false)

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  // console.log('disabledForm', disabledForm)

  const fixedValue = {
    durableArticlesTypeCode: '1800', //ค่าครุภัณฑ์
  }

  useEffect(() => {
    //setMasterTableData(schema.values)
    setShowAdditional(false)
    setTableData(schema.values)
    register('table', schema.values || [])
    setValue('table', schema.values || [])
  }, [schema.values])

  useEffect(() => {
    let datas = getValues('table') || []
    handleChangeTotal(datas)
  }, [borrowAmont])

  // console.log('payActive', payActive)
  // console.log('activityRelationsList', activityRelationsList)

  useEffect(() => {
    if (activityRelationsList.length > 0) {
      let convertData = activityRelationsList?.map((item) => {
        if (item.activityCode) {
        }
        return {
          ...item,
          label: item.typeName,
          value: item.typeCode,
        }
      })
      // console.log('payActive', payActive)
      //let _convertData = convertData.filter((i) => payActive == i.activityCode || !i.activityCode)

      let _convertData = [
        ...new Map(
          convertData
            // .filter((i) => payActive == i.activityCode || !i.activityCode)
            .filter((i) => payActive == i.activityCode)
            ?.map((item) => [item['typeCode'], item])
        ).values(),
      ]

      _convertData.sort((a, b) => parseInt(a.typeCode) - parseInt(b.typeCode))

      console.log('_convertData', _convertData)

      setListOptions(_convertData || [])
    }
  }, [payActive, activityRelationsList])

  const handleOpenEditRow = (rowData) => {
    // console.log('handleOpenEditRow ', rowData)
    // console.log('tableData ', tableData)
    // tableData.map((row) => {
    //   if (row.id == rowData.id) {
    //     // console.log('row ', row)
    //     const nextData = getNewDataEdit(tableData, row)
    //     setTableData(nextData)
    //   }
    // })

    const newData = tableData.map((row) => {
      if (row.id == rowData.id) {
        if (rowData.status && rowData.status == 'EDIT') {
          const master = masterTableData.find((item, index) => item.id == rowData.id)
          //let index = tableData.findIndex((item) => item.id === master.id)

          console.log('master', master)

          // setValue(`table[${index}].${schema.list.name}`, master.list)
          // setValue(`table[${index}].${schema.referenceNumber.name}`, master.referenceNumber)
          // setValue(`table[${index}].${schema.voucherDate.name}`, master.voucherDate)
          // setValue(`table[${index}].${schema.amount.name}`, master.amount)

          row.list = master?.list
          row.referenceNumber = master?.referenceNumber
          row.voucherDate = master?.voucherDate
          row.amount = master?.amount

          //row = master
          row.status = null
        } else {
          row.status = 'EDIT'
        }
      }
      return row
    })
    setTableData(newData)
    setValue('table', newData)
    handleChangeTotal(newData)
  }

  const onDeleteRow = (rowData) => {
    let datas = cloneDeep(tableData)

    datas = datas.filter((e) => e.id != rowData.id)

    var totalAmount = {}
    var totalRefund = {}
    var totalExtra = {}
    if (datas && datas?.length > 0) {
      totalAmount = datas[datas.length - 3]
      totalRefund = datas[datas.length - 2]
      totalExtra = datas[datas.length - 1]

      totalAmount.amount = 0
      totalRefund.amount = 0
      totalExtra.amount = 0

      datas?.splice(-1)
      datas?.splice(-1)
      datas?.splice(-1)
    } else {
      datas = []

      totalAmount = {
        id: '',
        list: '',
        voucherDate: '',
        cashAccountOnHand: 'รวมตามหลักฐานการจ่าย',
        amount: 0,
        isRowTotal: true,
        isTotalAmount: true,
      }
      totalRefund = {
        id: '',
        list: '',
        voucherDate: '',
        cashAccountOnHand: 'จำนวนเงินรับคืน',
        amount: 0,
        isRowTotal: true,
        isTotalRefund: true,
      }
      totalExtra = {
        id: '',
        list: '',
        voucherDate: '',
        cashAccountOnHand: 'จำนวนเงินเบิกเพิ่ม',
        amount: 0,
        isRowTotal: true,
        isTotalExtra: true,
      }
    }

    datas.forEach((e) => {
      totalAmount.amount = totalAmount.amount + e.amount
    })
    let diffAmount = borrowAmont - totalAmount.amount || 0
    if (diffAmount < 0) {
      //if negative number
      totalRefund.amount = 0
      totalExtra.amount = diffAmount * -1 //change negative to positive
    } else {
      totalRefund.amount = diffAmount
      totalExtra.amount = 0
    }

    datas.push(totalAmount)
    datas.push(totalRefund)
    datas.push(totalExtra)

    setTableData(datas)
    setValue('table', datas)
    handleChangeTotal(datas)
  }
  // setShowControlEdit(!showControlEdit)

  const handleOnClickAddNewData = () => {
    let datas = cloneDeep(tableData)

    var runnigNum = 0
    var totalAmount = {}
    var totalRefund = {}
    var totalExtra = {}
    if (datas && datas?.length > 0) {
      runnigNum = datas.length - 1
      totalAmount = datas[datas.length - 3]
      totalRefund = datas[datas.length - 2]
      totalExtra = datas[datas.length - 1]

      totalAmount.amount = 0
      totalRefund.amount = 0
      totalExtra.amount = 0

      datas?.splice(-1)
      datas?.splice(-1)
      datas?.splice(-1)
    } else {
      datas = []

      totalAmount = {
        id: '',
        list: '',
        voucherDate: '',
        cashAccountOnHand: 'รวมตามหลักฐานการจ่าย',
        amount: 0,
        isRowTotal: true,
        isTotalAmount: true,
      }
      totalRefund = {
        id: '',
        list: '',
        voucherDate: '',
        cashAccountOnHand: 'จำนวนเงินรับคืน',
        amount: 0,
        isRowTotal: true,
        isTotalRefund: true,
      }
      totalExtra = {
        id: '',
        list: '',
        voucherDate: '',
        cashAccountOnHand: 'จำนวนเงินเบิกเพิ่ม',
        amount: 0,
        isRowTotal: true,
        isTotalExtra: true,
      }
    }

    var newObj = {
      id: 'addNew-' + runnigNum + '-' + uuidv4(),
      list: '',
      voucherDate: moment().startOf('day').toDate(),
      cashAccountOnHand: '',
      amount: 0,
      isDeletable: true,
      status: 'EDIT',
    }

    datas.push(newObj)

    datas.forEach((e) => {
      totalAmount.amount = totalAmount.amount + e.amount
    })

    let diffAmount = borrowAmont - totalAmount.amount || 0
    if (diffAmount < 0) {
      //if negative number
      totalRefund.amount = 0
      totalExtra.amount = diffAmount * -1 //change negative to positive
    } else {
      totalRefund.amount = diffAmount
      totalExtra.amount = 0
    }

    datas.push(totalAmount)
    datas.push(totalRefund)
    datas.push(totalExtra)

    setTableData(datas)
    setValue('table', datas)
    handleChangeTotal(datas)
  }

  const onChangeCellValue = (index, value, key) => {
    console.log('value => ', value)

    if (value == fixedValue.durableArticlesTypeCode) {
      setShowWarning(true)
      setShowAdditional(true)
    } else {
      setShowAdditional(false)
    }

    let datas = cloneDeep(tableData)

    datas[index][key] = value
    setValue(`table[${index}].${schema[key].name}`, value)

    setTableData(datas)
    setValue('table', datas)
  }

  const onChangeAmountValue = (index, value = 0) => {
    let datas = cloneDeep(tableData)

    console.log('value => ', value)

    datas[index].amount = value
    //setValue(`table[${index}].${schema.amount.name}`, value)

    setTableData(datas)
    setValue('table', datas)

    handleChangeTotal(datas)
  }

  const handleChangeTotal = (dataTable) => {
    // console.log('tableData', tableData)
    // console.log('tableData getValue',  getValues('table'))

    if (dataTable?.length > 0) {
      var totalAmount = 0
      var totalRefund = 0
      var totalExtra = 0
      dataTable.forEach((e) => {
        if (!e.isRowTotal) {
          totalAmount = totalAmount + e.amount
        }
      })

      let diffAmount = borrowAmont - totalAmount || 0
      if (diffAmount < 0) {
        //if negative number
        totalRefund = 0
        totalExtra = diffAmount * -1 //change negative to positive
      } else {
        totalRefund = diffAmount
        totalExtra = 0
      }

      setValue(`table[${dataTable.length - 3}].${schema.amount.name}`, totalAmount)
      setValue(`table[${dataTable.length - 2}].${schema.amount.name}`, totalRefund)
      setValue(`table[${dataTable.length - 1}].${schema.amount.name}`, totalExtra)
    }
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.amount && !cur.isRowTotal) {
        return pre + cur.amount
      }
      return pre
    }, 0)
  }

  return (
    <>
      <div className="table-affix-header">
        <Table
          shouldUpdateScroll={false}
          wordWrap
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
          headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
          affixHeader
        >
          <Column width={70} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return ''
                }
                return <span>{index + 1}</span>
              }}
            </Cell>
          </Column>

          <Column width={200} minWidth={200} flexGrow={1}>
            <HeaderCell style={styleHeaderCell}>รายการ/ประเภทรายจ่าย</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.status != 'EDIT') {
                  return getValueFromOptions(listOptions, rowData?.list)
                }

                return (
                  <EditSelectCell
                    id={`${schema.list.name}_${rowData.id}`}
                    rowData={rowData}
                    searchable={true}
                    //rowSchema={schema.list}
                    rowSchema={{
                      ...schema.list,
                      options: listOptions,
                    }}
                    dataKey={schema.list.name}
                    register={register}
                    control={control}
                    errors={errors}
                    disabled={!isEnableEdit || isReceiveAnnuity}
                    onChangeCell={(value) => onChangeCellValue(index, value, schema.list.name)}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell style={styleHeaderCell}>เลขที่เอกสารอ้างอิง</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return <b>{rowData.referenceNumber}</b>
                }

                return (
                  <EditTextCell
                    id={`${schema.referenceNumber.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.referenceNumber.name}`}
                    rowSchema={schema.referenceNumber}
                    rowData={rowData}
                    dataKey={schema.referenceNumber.name}
                    register={register}
                    control={control}
                    errors={errors}
                    onChangeCell={(value) =>
                      onChangeCellValue(index, value, schema.referenceNumber.name)
                    }
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell style={styleHeaderCell}>วันที่เอกสาร</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <div style={{ width: '100%', textAlign: 'right' }}>
                      <b>{rowData.cashAccountOnHand}</b>
                    </div>
                  )
                } else {
                  if (rowData.status != 'EDIT') {
                    return (
                      <span>
                        {moment(rowData.voucherDate, 'MM/DD/YYYY')
                          ?.add(543, 'years')
                          //.toDate()
                          //.toLocaleDateString('th-TH')
                          ?.format('DD MMM YYYY')}
                      </span>
                    )
                  }

                  return (
                    <EditDateCustomCell
                      id={`${schema.voucherDate?.name}_${rowData.id}`}
                      //id={`table[${index}].${schema.voucherDate.name}`}
                      rowData={{
                        ...rowData,
                        voucherDate: rowData.voucherDate
                          ? moment(rowData.voucherDate).format('DD/MM/YYYY')
                          : moment().startOf('day').toDate(),
                      }}
                      dataKey={schema.voucherDate?.name}
                      register={register}
                      control={control}
                      errors={errors}
                      onChangeCell={(value) =>
                        onChangeCellValue(index, value, schema.voucherDate.name)
                      }
                      endDate={new Date()}
                      // startDate={_startProjectDate}
                      // endDate={_endProjectDate}
                      // defaultDate={defaultDate}
                    />
                  )
                }
              }}
            </Cell>
          </Column>

          <Column width={200} align="right">
            <HeaderCell style={styleHeaderCell}>จำนวนเงิน (บาท)</HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isRowTotal) {
                  return (
                    <Controller
                      name={`table[${index}].${schema.amount.name}`}
                      control={control}
                      defaultValue={rowData.amount || 0}
                      render={(props) => {
                        return (
                          <span className={'cost-total-summary'}>
                            <b>{budgetFormat(props.value)}</b>
                          </span>
                        )
                      }}
                    />
                  )
                }

                return (
                  <EditNumberCell
                    //id={`${schema.amount.name}_${rowData.id}`}
                    id={`table[${index}].${schema.amount.name}`}
                    rowData={rowData}
                    dataKey={schema.amount.name}
                    register={register}
                    control={control}
                    errors={errors}
                    isRequired={true}
                    isBudgetFormat={true}
                    disabled={!isEnableEdit || isReceiveAnnuity}
                    styleSheet={{ marginTop: 8, textAlign: 'right' }}
                    onChangeCell={(value) => onChangeAmountValue(index, value)}
                    allowNegative={!hasMinValidator(schema.amount.validators)}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="center">
            <HeaderCell>วันที่บันทึกรายการ</HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          {/* <Column width={200} align="right">
          <HeaderCell style={styleHeaderCell}>หัก ณ.ที่จ่าย</HeaderCell>
          <Cell align="right">
            {(rowData, index) => {
              return (
                <EditNumberCell
                  //id={`${schema.withholding.name}_${rowData.id}`}
                  id={`table[${index}].${schema.withholding.name}`}
                  rowData={rowData}
                  dataKey={schema.withholding.name}
                  register={register}
                  control={control}
                  errors={errors}
                  isRequired={true}
                  isBudgetFormat={true}
                  disabled={!isEnableEdit || isReceiveAnnuity}
                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  onChangeCell={(value) => onChangeTableValue(index, value, schema.withholding.name)}
                />
              )
            }}
          </Cell>
        </Column>

        <Column width={200} align="right">
          <HeaderCell style={styleHeaderCell}>จำนวนเงินรับจริง</HeaderCell>
          <Cell align="right">
            {(rowData, index) => {
              return (
                <EditNumberCell
                  //id={`${schema.receivedAmount.name}_${rowData.id}`}
                  id={`table[${index}].${schema.receivedAmount.name}`}
                  rowData={rowData}
                  dataKey={schema.receivedAmount.name}
                  register={register}
                  control={control}
                  errors={errors}
                  isRequired={true}
                  isBudgetFormat={true}
                  disabled={!isEnableEdit || isReceiveAnnuity}
                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  onChangeCell={(value) => onChangeTableValue(index, value, schema.receivedAmount.name)}
                />
              )
            }}
          </Cell>
        </Column> */}

          {!isViewMode && (
            <Column width={200} align="center" fixed="right">
              <HeaderCell style={styleHeaderCell}>จัดการรายการ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  // console.log('row ', rowData.isRowTotal)
                  // if (index == tableData.length - 1) {
                  //   return (
                  //     <>
                  //       {!isReceiveAnnuity && (
                  //         <IconButton
                  //           appearance="ghost"
                  //           icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                  //           onClick={handleOnClickAddNewData}
                  //           // disabled={disabledButton}
                  //           style={{ marginLeft: 5 }}
                  //         >
                  //           {'เพิ่มรายการ'}
                  //         </IconButton>
                  //       )}
                  //     </>
                  //   )
                  // }

                  if (rowData.isRowTotal) {
                    return ''
                  }

                  return (
                    <>
                      {rowData.id?.indexOf('addNew') == -1 && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={
                            <Icon
                              icon={rowData.status == 'EDIT' ? 'close' : 'edit'}
                              className="bt-gost-icon-radius-edit"
                            />
                          }
                          onClick={() => handleOpenEditRow(rowData)}
                          disabled={disabledForm}
                          size="sm"
                        >
                          {rowData.status == 'EDIT' ? 'ยกเลิก' : 'แก้ไข'}
                        </IconButton>
                      )}
                      {!isReceiveAnnuity && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={() => {
                            onDeleteRow(rowData)
                          }}
                          size="sm"
                          style={{ marginLeft: 5 }}
                        >
                          ลบ
                        </IconButton>
                      )}
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      {!isReceiveAnnuity && (
        <div style={{ marginTop: 10 }}>
          {!isViewMode && (
            <Row>
              <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <IconButton
                  appearance="ghost"
                  icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                  onClick={() => handleOnClickAddNewData()}
                  style={{ marginLeft: 5 }}
                  disabled={disabledForm || isAddDisabled}
                >
                  {'เพิ่มรายการ'}
                </IconButton>
              </Col>
            </Row>
          )}
        </div>
      )}

      {/* {console.log(
        'tableData',
        tableData.find((i) => i.list == fixedValue.durableArticlesTypeCode)
      )} */}

      <div style={{ marginTop: 10 }}>
        {!isViewMode
          ? tableData.find((i) => i.list == fixedValue.durableArticlesTypeCode) &&
            assetInputReason && (
              <Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <ControlLabel>
                    {requiredFiled(assetInputReason.validators, assetInputReason.label)}
                  </ControlLabel>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <ErrorMessage error={errors[assetInputReason.name]} />
                  <Controller
                    name={assetInputReason.name}
                    control={control}
                    defaultValue={assetInputReason.value || ''}
                    rules={isValidators(assetInputReason.validators)}
                    render={(props) => {
                      return (
                        <>
                          <Input
                            componentClass="textarea"
                            rows={4}
                            placeholder={'ระบุ' + assetInputReason.label}
                            value={props.value}
                            maxLength={getMaxLengthData(assetInputReason.validators).value}
                            onChange={(value, e) => {
                              props.onChange(value)
                            }}
                            disabled={assetInputReason.disabled}
                          />
                          <ShowLimitLength
                            textLength={props.value?.length || 0}
                            maxLength={getMaxLengthData(assetInputReason.validators)?.value}
                          />
                        </>
                      )
                    }}
                  />
                </Col>
              </Row>
            )
          : tableData.find((i) => i.list == fixedValue.durableArticlesTypeCode) &&
            assetInputReason && (
              <>
                <p>{assetInputReason?.label || 'เหตุผลเพิ่มเติมเพื่อประกอบการพิจารณา'}</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{assetInputReason?.value || '-ไม่พบข้อมูล-'}</p>
              </>
            )}
      </div>

      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        // onConfirm={handleOnConfirmDelete}
      />

      <AlertWidget
        title={`การแจ้งเตือน`}
        show={showWarning}
        useHtmlTag
        size="lg"
        detail={<div dangerouslySetInnerHTML={{ __html: assetInputAlertDescription || '' }} />}
        onClose={() => {
          setShowWarning(false)
        }}
      />
    </>
  )
}
